import Vue from "vue";
import BaseForm from "./BaseForm/Index.vue";
import BaseTextField from "./BaseTextField/Index.vue";
import BaseSelect from "./BaseSelect/Index.vue";

Vue.component("base-form", BaseForm);
Vue.component("base-text-field", BaseTextField);
Vue.component("base-select", BaseSelect);
